import { FC, Suspense } from 'react';
import { TrackerScript } from './tracker-script';
import { TrackerQueue } from './tracker-queue';
import { TrackClickAttribution } from './track-click-attribution';
import { TrackFormAttribution } from './track-form-attribution';
import { ClientMessageSender } from './client-message-sender';
import { ConsentDialogObserver } from './consent-dialog-observer';
export type TrackerProps = {
  // App-Based possibility to disable tracking
  disableTracking?: boolean;
};
export const Tracker: FC<TrackerProps> = props => {
  return <Suspense data-sentry-element="Suspense" data-sentry-component="Tracker" data-sentry-source-file="tracker.tsx">
      <TrackerScript disableTracking={props.disableTracking} data-sentry-element="TrackerScript" data-sentry-source-file="tracker.tsx" />
      <TrackClickAttribution data-sentry-element="TrackClickAttribution" data-sentry-source-file="tracker.tsx" />
      <TrackFormAttribution data-sentry-element="TrackFormAttribution" data-sentry-source-file="tracker.tsx" />
      <TrackerQueue data-sentry-element="TrackerQueue" data-sentry-source-file="tracker.tsx" />
      <ClientMessageSender data-sentry-element="ClientMessageSender" data-sentry-source-file="tracker.tsx" />
      <ConsentDialogObserver data-sentry-element="ConsentDialogObserver" data-sentry-source-file="tracker.tsx" />
    </Suspense>;
};